'use strict';

exports.__esModule = true;
exports.RemoteGlobalsInterface = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RemoteGlobalsInterface = function () {
  function RemoteGlobalsInterface(modelJson) {
    _classCallCheck(this, RemoteGlobalsInterface);

    this._globals = modelJson || {
      navigation: {},
      sessionInfo: {},
      appsData: {},
      siteMemberData: { uid: null, permissions: null, onUserLogin: [] },
      multilingualInfo: { isEnabled: false, currentLanguageCode: null, siteLanguages: [], onCurrentLanguageChange: [] },
      appStudioWidgetData: { isApplicationStudio: false, onPropsChanged: [] },
      deviceType: null,
      isMobileFriendly: null,
      lightboxContext: {},
      contextId: null
    };
  }

  RemoteGlobalsInterface.prototype.addNavigation = function addNavigation(navigationData) {
    this._globals.navigation = navigationData;
  };

  RemoteGlobalsInterface.prototype.addSiteMemberData = function addSiteMemberData(siteMemberData) {
    var shouldTriggerOnLoginCallback = siteMemberData.uid && siteMemberData.uid !== this._globals.siteMemberData.uid;
    _lodash2.default.assign(this._globals.siteMemberData, siteMemberData);
    if (shouldTriggerOnLoginCallback) {
      var onUserLoginCallbacks = this._globals.siteMemberData.onUserLogin;
      _lodash2.default.forEach(onUserLoginCallbacks, function (callback) {
        callback(siteMemberData);
      });
    }
  };

  RemoteGlobalsInterface.prototype.addAppsData = function addAppsData(appsData) {
    this._globals.appsData = appsData;
  };

  RemoteGlobalsInterface.prototype.addOnUserLoginCallback = function addOnUserLoginCallback(callback) {
    this._globals.siteMemberData.onUserLogin.push(callback);
  };

  RemoteGlobalsInterface.prototype.addSessionInfoProp = function addSessionInfoProp(_addSessionInfoProp) {
    _lodash2.default.assign(this._globals.sessionInfo, _addSessionInfoProp);
  };

  RemoteGlobalsInterface.prototype.addDeviceType = function addDeviceType(deviceType) {
    this._globals.deviceType = deviceType;
  };

  RemoteGlobalsInterface.prototype.addIsMobileFriendly = function addIsMobileFriendly(isMobileFriendly) {
    this._globals.isMobileFriendly = isMobileFriendly;
  };

  RemoteGlobalsInterface.prototype.addLightboxContext = function addLightboxContext(lightboxContext) {
    this._globals.lightboxContext = lightboxContext;
  };

  RemoteGlobalsInterface.prototype.addContextId = function addContextId(contextId) {
    this._globals.contextId = contextId;
  };

  RemoteGlobalsInterface.prototype.addMultilingualInfo = function addMultilingualInfo(multilingualInfo) {
    var shouldTriggerOnCurrentLanguageChange = multilingualInfo.currentLanguageCode && multilingualInfo.currentLanguageCode !== this._globals.multilingualInfo.currentLanguageCode;

    _lodash2.default.assign(this._globals.multilingualInfo, multilingualInfo);
    if (shouldTriggerOnCurrentLanguageChange) {
      var onCurrentLanguageChangeCallbacks = this._globals.multilingualInfo.onCurrentLanguageChange;
      _lodash2.default.forEach(onCurrentLanguageChangeCallbacks, function (callback) {
        callback(multilingualInfo);
      });
    }
  };

  RemoteGlobalsInterface.prototype.addOnCurrentLanguageChangeCallback = function addOnCurrentLanguageChangeCallback(callback) {
    this._globals.multilingualInfo.onCurrentLanguageChange.push(callback);
  };

  //Getters

  RemoteGlobalsInterface.prototype.getAppsData = function getAppsData() {
    return _lodash2.default.cloneDeep(this._globals.appsData);
  };

  RemoteGlobalsInterface.prototype.getDeviceType = function getDeviceType() {
    return this._globals.deviceType;
  };

  RemoteGlobalsInterface.prototype.getIsMobileFriendly = function getIsMobileFriendly() {
    return this._globals.isMobileFriendly;
  };

  RemoteGlobalsInterface.prototype.getLightboxContext = function getLightboxContext() {
    return _lodash2.default.cloneDeep(this._globals.lightboxContext);
  };

  RemoteGlobalsInterface.prototype.getContextId = function getContextId() {
    return this._globals.contextId;
  };

  //Getters

  RemoteGlobalsInterface.prototype.getAppData = function getAppData(appDefinitionId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._globals.appsData, appDefinitionId));
  };

  RemoteGlobalsInterface.prototype.getNavigationInfo = function getNavigationInfo() {
    return _lodash2.default.cloneDeep(this._globals.navigation);
  };

  RemoteGlobalsInterface.prototype.getSiteMemberData = function getSiteMemberData(appDefinitionId) {
    var siteMemberData = _lodash2.default.cloneDeep(this._globals.siteMemberData);
    if (appDefinitionId) {
      var appData = _lodash2.default.get(this._globals.appsData, appDefinitionId);
      if (appData) {
        _lodash2.default.assign(siteMemberData, _lodash2.default.pick(appData, ['instance', 'instanceId']));
      }
    }
    return siteMemberData;
  };

  RemoteGlobalsInterface.prototype.getMultilingualInfo = function getMultilingualInfo() {
    return _lodash2.default.cloneDeep(this._globals.multilingualInfo);
  };

  RemoteGlobalsInterface.prototype.getCurrentLanguageCode = function getCurrentLanguageCode() {
    return this._globals.multilingualInfo.currentLanguageCode;
  };

  RemoteGlobalsInterface.prototype.getSiteLanguages = function getSiteLanguages() {
    return this._globals.multilingualInfo.siteLanguages;
  };

  RemoteGlobalsInterface.prototype.getIsMultilingualEnabled = function getIsMultilingualEnabled() {
    return this._globals.multilingualInfo.isEnabled;
  };

  RemoteGlobalsInterface.prototype.getSessionInfo = function getSessionInfo() {
    return _lodash2.default.cloneDeep(this._globals.sessionInfo);
  };

  RemoteGlobalsInterface.prototype.addIsApplicationStudio = function addIsApplicationStudio(isApplicationStudio) {
    this._globals.appStudioWidgetData.isApplicationStudio = isApplicationStudio;
  };

  RemoteGlobalsInterface.prototype.getIsApplicationStudio = function getIsApplicationStudio() {
    return this._globals.appStudioWidgetData.isApplicationStudio;
  };

  RemoteGlobalsInterface.prototype.addOnWidgetPropsChangedCallback = function addOnWidgetPropsChangedCallback(callback) {
    this._globals.appStudioWidgetData.onPropsChanged.push(callback);
  };

  RemoteGlobalsInterface.prototype.triggerWidgetPropsChanged = function triggerWidgetPropsChanged(oldProps, newProps) {
    _lodash2.default.forEach(this._globals.appStudioWidgetData.onPropsChanged, function (callback) {
      callback(_lodash2.default.cloneDeep(oldProps), _lodash2.default.cloneDeep(newProps));
    });
  };

  RemoteGlobalsInterface.prototype.toJson = function toJson() {
    return this._globals;
  };

  return RemoteGlobalsInterface;
}();

exports.RemoteGlobalsInterface = RemoteGlobalsInterface;
//# sourceMappingURL=RemoteGlobalsInterface.js.map